import React, { useState, useEffect } from 'react';
import { headingClasses, textClasses, sectionClasses } from '../../styles/typography';

const Testimonials = () => {
  // מידע עבור ציטוטים
  const testimonials = [
    { 
      quote: "Terrible solution, I don't have any more work", 
      author: "Alex, Freelance App Developer" 
    },
    { 
      quote: "I used AI to design, code, and test. But I was still dragging AABs like it's 2015... Not anymore.", 
      author: "Michael, Solo Founder" 
    },
    { 
      quote: "Got my app published in record time", 
      author: "Sarah, Startup Founder" 
    },
    { 
      quote: "Absolutely brilliant service", 
      author: "Mo, Mobile Developer" 
    },
  ];
  
  // מצב עבור הציטוט הנוכחי
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  // אפקט שמשנה את הציטוט הנוכחי כל 6 שניות
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
    }, 6000);
    
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <div className={`${sectionClasses.darkSection} pt-16 pb-24`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* סקשן ציטוטים */}
        <div className="mb-10 flex flex-col items-center w-full">
          {/* הציטוט עצמו */}
          <div className="text-center relative min-h-[180px] flex flex-col items-center justify-center w-full">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className={`absolute transition-all duration-1000 ease-in-out w-full flex flex-col items-center transform
                  ${index === currentTestimonial 
                    ? 'opacity-100 translate-y-0' 
                    : 'opacity-0 pointer-events-none translate-y-4'}`}
              >
                <h2 className={headingClasses.hero}>
                  "{testimonial.quote}"
                </h2>
                <p className={`${textClasses.body} mt-4 text-center transition-opacity duration-700 delay-100`}>
                  {testimonial.author}
                </p>
              </div>
            ))}
          </div>
          
          {/* אינדיקטורים למיקום בקרוסלה */}
          <div className="flex space-x-3 mt-10">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`h-3 w-3 rounded-full transition-all duration-500 ease-in-out 
                  ${index === currentTestimonial ? 'bg-text-white' : 'bg-text-gray-lighter hover:bg-text-gray-light'}`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
        
        {/* קו ארוך מתחת לכל התוכן */}
        <div className="w-full mt-32 flex justify-center">
          <div className="w-full h-[2px] bg-gradient-to-r from-transparent via-gray-600 to-transparent"></div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials; 